<template>
	<ul>
		<li v-for="questionnaire in questionnaires" :key="questionnaire.id">
			<router-link :to="'/outcome/'+ questionnaire.id">
				{{ questionnaire.display_name ? questionnaire.display_name : questionnaire.title }}
			</router-link>
		</li>
	</ul>
</template>

<script>
import SidebarList from '.'

export default {
	name: 'sidebar-questionnaire-list',
	extends: SidebarList,

	watch: {
		questionnaireIds: {
			immediate: true,
			handler(ids) {
				if (Array.isArray(ids)) {
					let missing = ids.filter((id) => this.getContent('questionnaire', id) == null)
					if(missing.length > 0) {
						this.loadContent({
							type: 'questionnaire',
							id: missing
						})
					}
				}
			}
		}	
	},

	computed: {
		questionnaireIds() {
			if (this.profiles) {
				var ids = this.profiles.flatMap((profile) => {
					let questionnaire = this.getContentKey('profile', profile.id, 'survey_questionnaire')
					return questionnaire || []
				})
				var deduplicate = {}
				ids.forEach((id) => { deduplicate[id] = true })
				return Object.keys(deduplicate)
			}
			return null
		},

		questionnaires() {
			if (this.questionnaireIds)
				return this.questionnaireIds
					.map((id) => this.getContent('questionnaire', id))
					.filter((q) => q != null)
					.slice()
			return []
		}
	}
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>
